import React from 'react';
import PropTypes from 'prop-types';
import s from './SelectBox.styles';

const SingleValueWithIcon = ({ data }) => (
  <div className="input-select">
    <div className="input-select__single-value">
      {data.icon && <s.QuestionTypeIcon name={data.icon} />}
      <span>{data.label}</span>
    </div>
  </div>
);

SingleValueWithIcon.propTypes = {
  data: PropTypes.shape({
    label: PropTypes.string,
    icon: PropTypes.string,
  }),
};

export default React.memo(SingleValueWithIcon);
